export default __webpack_public_path__ + "static/media/scan-book-white.330d2f44.svg";